import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { reportApiErrorDiagnostics } from '~/helpers/apiErrorDiagnostics.reporter';
import { isResponseHeaders } from '~/helpers/errorDiagnostics.helper';
import { axiosWithRetry } from '~/services/api';

let isRegistered = false;

export const registerApiErrorDiagnosticsInterceptor = (
  dispatch: Dispatch<AnyAction>
): void => {
  if (isRegistered) {
    return;
  }
  isRegistered = true;

  const onRejected = (error: AxiosError) => {
    const headers = error.response?.headers;

    if (isResponseHeaders(headers)) {
      reportApiErrorDiagnostics(dispatch, headers);
    }

    return Promise.reject(error);
  };

  // axios.create() does not inherit interceptors, so both instances need registering.
  axios.interceptors.response.use(undefined, onRejected);
  axiosWithRetry.interceptors.response.use(undefined, onRejected);
};
